/* eslint-disable prefer-destructuring */
export const ELOQUA_URL = process.env.ELOQUA_URL;
export const CAMPAIGN_ID_CONNECTION = '7010H000001eqZP';
export const CAMPAIGN_ID_EVENTS = '7010H000001eqZF';
export const CAMPAIGN_ID_ADV_AWARENESS = '7010H000001eqZU';
export const CAMPAIGN_ID_EDIT_PROFILE = '7010H000001evi2';
export const CAMPAIGN_ID_COLLEGE_SCHOLARSHIPS = '7010H000001nFVxQAM';
export const MARKETO_CAMPAIGN_ID = `${process.env.MARKETO_CAMPAIGN_ID}` || '7012K000001qP4yQAE';

export const ELOQUA_SUBSCRIPTION_CAMPAIGN_IDS = {
  amplus: CAMPAIGN_ID_CONNECTION,
  events: CAMPAIGN_ID_EVENTS,
  advancedawareness: CAMPAIGN_ID_ADV_AWARENESS,
  connection: CAMPAIGN_ID_CONNECTION,
  editprofile: CAMPAIGN_ID_EDIT_PROFILE,
  scholarships: CAMPAIGN_ID_COLLEGE_SCHOLARSHIPS,
};

export const MARKETO_LEAD_SOURCE = {
  amplus: 'Connection',
  events: 'Events',
  advancedawareness: 'Advanced Awareness',
  connection: 'Connection',
  editprofile: 'Premium Hem',
  scholarships: 'Scholarships',
};

export const PRIVACY_URL = `${process.env.PRIVACY_URL}`;

export default ELOQUA_URL;
